export default function stringUtils(): any {
  const equals = (s1: string, s2: string): boolean => {
    return s1 === s2;
  };

  const empty = (str: string): boolean => {
    return str === undefined || str === null || str.trim().length === 0;
  };

  const notEmpty = (str: string): boolean => {
    return str !== undefined && str !== null && str.trim().length > 0;
  };

  return {
    equals,
    empty,
    notEmpty,
  };
}
